import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import { api_crud_base, api_crud_route, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import Calendar from '@toast-ui/react-calendar';
import 'tui-calendar/dist/tui-calendar.css';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

import {

	reqGET,
	reqPOST,
	reqPUT

} from '../../../Utils';

import { language } from './Language';

export default function Regist(props) {
	
	const [schedueles, setSchedueles] = useState([]);
    const [calendars, setCalendars] = useState([]);
    const [selectedView, setSelectedView] = useState('day');

    const [modal_name, set_modal_name] = useState('');
    const [modal_category, set_modal_category] = useState('');
    const [modal_category_id, set_modal_category_id] = useState('0');
    const [modal_date, set_modal_date] = useState('');
    const [modal_horario, set_modal_horario] = useState([]);
    const [modal_instrutor_id, set_modal_instrutor_id] = useState('');
    const [modal_instrutor_name, set_modal_instrutor_name] = useState('');

    // const [modal_event_id, ] = useState('');

    const [instrutores, ] = useState([]);

    const [, set_horarios_agendados] = useState([]);

    const [isloading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(0);

	const [lang, set_lang] = useState('pt');

    const [aulas_types, ] = useState([
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	])
    const [horario, set_horario] = useState([
        {value:'0', label: '09:30 - 10:30', begin: '09:30', end: '10:30', state: true},
        {value:'1', label: '10:00 - 11:00', begin: '10:00', end: '11:00', state: true},
        {value:'2', label: '10:30 - 11:30', begin: '10:30', end: '11:30', state: true},
        {value:'3', label: '11:00 - 12:00', begin: '11:00', end: '12:00', state: true},
        {value:'4', label: '11:30 - 12:30', begin: '11:30', end: '12:30', state: true},
        {value:'5', label: '12:00 - 13:00', begin: '12:00', end: '13:00', state: true},
        {value:'6', label: '12:30 - 13:30', begin: '12:30', end: '13:30', state: true},
        {value:'7', label: '13:00 - 14:00', begin: '13:00', end: '14:00', state: true},
        {value:'8', label: '13:30 - 14:30', begin: '13:30', end: '14:30', state: true},
        {value:'9', label: '14:00 - 15:00', begin: '14:00', end: '15:00', state: true},
        {value:'10', label: '14:30 - 15:30', begin: '14:30', end: '15:30', state: true},
        {value:'11', label: '15:00 - 16:00', begin: '15:00', end: '16:00', state: true},
        {value:'12', label: '15:30 - 16:30', begin: '15:30', end: '16:30', state: true}
    ])
    /*
    const [horario_start, ] = useState([
        {value: '09:30', label: '09:30'},
        {value: '10:00', label: '10:00'},
        {value: '10:30', label: '10:30'},
        {value: '11:00', label: '11:00'},
        {value: '11:30', label: '11:30'},
        {value: '12:00', label: '12:00'},
        {value: '12:30', label: '12:30'},
        {value: '13:00', label: '13:00'},
        {value: '13:30', label: '13:30'},
        {value: '14:00', label: '14:00'},
        {value: '14:30', label: '14:30'},
        {value: '15:00', label: '15:00'},
        {value: '15:30', label: '15:30'}
    ])
    const [horario_end, ] = useState([
        {value: '10:30', label: '10:30'},
        {value: '11:00', label: '11:00'},
        {value: '11:30', label: '11:30'},
        {value: '12:00', label: '12:00'},
        {value: '12:30', label: '12:30'},
        {value: '13:00', label: '13:00'},
        {value: '13:30', label: '13:30'},
        {value: '14:00', label: '14:00'},
        {value: '14:30', label: '14:30'},
        {value: '15:00', label: '15:00'},
        {value: '15:30', label: '15:30'},
        {value: '16:00', label: '16:00'},
        {value: '16:30', label: '16:30'}
    ])
    */

    var today = new Date()
    // const [data, set_data] = useState((today.getFullYear() + '').padStart(2, '0') + '-' + ((today.getMonth() + 1) + '').padStart(2, '0') + '-' + (today.getDate() + '').padStart(2, '0'));
    const [calendarTitle, setcalendarTitle] = useState(today.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));

    const data_interface_event = {
        id: '',
        info: {
            companycode: '',
            name: '',
            category: '',
            observation: '',
            description: '',
            detail: {   
                start:  '',
                end:    '',
                location: {id: '', name: ''},
                nivel: '',              // Iniciação | Intermédio | Avançado
                calendarId: '0',        // 0 - "" | 1 - Ski | 2 - Snowboard
                category: "time",
                state: "free",          // free | busy | done
                raw: { class: 'public' },
                dueDateClass: '',
                isAllDay: false,
                isReadOnly: true,
            },
            instrutor: {
                id: '',
                name: '',
            },
            inscritos: [
                {
                    name: '',
                    age: '',
                    identification_type: '',
                    identification_number: '',
                    codigo_compra: ''
                }
            ],
            media: {
                id: '',
                link: '',
            },  
            order: 0,
            status: true,
            language: []
        }
    }

    var calendar_views = [
        {
            name: language[lang].calendar_month,
            value: 'month'
        }, 
        {
            name: language[lang].calendar_week,
            value: 'week'
        },
        {
            name: language[lang].calendar_day,
            value: 'day'
        }
    ]

    const getDate = (type, start, value, operator) => {
        start = new Date(start);
        type = type.charAt(0).toUpperCase() + type.slice(1);
    
        if (operator === '+') {
            start[`set${type}`](start[`get${type}`]() + value);
        } 
        else {
            start[`set${type}`](start[`get${type}`]() - value);
        }
    
        return start;
    };

    const aux_schedueles = [
        {
            id: '1',
            calendarId: '1',
            title: 'TOAST UI Calendar Study',
            category: 'time',
            dueDateClass: '',
            start: today.toISOString(),
            end: getDate('hours', today, 3, '+').toISOString()
        },
        {
            id: '2',
            calendarId: '0',
            title: 'Practice',
            category: 'time',
            dueDateClass: '',
            start: getDate('date', today, 1, '+').toISOString(),
            end: getDate('date', today, 1, '+').toISOString(),
            isReadOnly: true
        },
        {
            id: '3',
            calendarId: '0',
            title: 'FE Workshop',
            category: 'allday',
            dueDateClass: '',
            start: getDate('date', today, 2, '-').toISOString(),
            end: getDate('date', today, 1, '-').toISOString(),
            isReadOnly: true
        },
        {
            id: '4',
            calendarId: '0',
            title: 'Report',
            category: 'milestone',
            dueDateClass: '',
            start: today.toISOString(),
            end: getDate('hours', today, 1, '+').toISOString()
        }
    ]

    // const aux_calendars = [
    //     {
    //         id: '0',
    //         name: 'Busy',
    //         bgColor: '#9e5fff',
    //         borderColor: '#9e5fff',
    //         status: true
    //     },
    //     {
    //         id: '1',
    //         name: 'Free',
    //         bgColor: '#00a9ff',
    //         borderColor: '#00a9ff',
    //         status: true
    //     },
    //     {
    //         id: '2',
    //         name: 'Done',
    //         bgColor: '#013b5a',
    //         borderColor: '#013b5a',
    //         status: true
    //     }
    // ]

    const get_events = async (start, end) => {

        //await reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${start}`)
        await reqGET(`${api_crud_base}/estancia/aula/event/instrutor/range/${getTokenInfo().companycode}/${props.location.state.item.id}/${start}/${end}`)
            .then(res => { 

                let aux_schedueles = []
                res.data.forEach((v) => {
                    if(v.info.instrutor.id === props.location.state.item.id) {
                        // console.log(v.info.detail.state)
                        aux_schedueles.push({
                            id: v.id,
                            companycode: v.info.companycode,
                            //calendarId: v.info.detail.calendarId,
                            calendarId: v.info.detail.state === 'busy' ? '0' : (v.info.detail.state === 'done' ? '2' : v.info.detail.state === 'cancel' ? '3' : '1'),
                            //title: (v.info.detail.name !== undefined && v.info.detail.name !== '' ? v.info.detail.name : 'Disponível'),
                            title: (v.info.detail.state === 'busy' ? 'Agendada' : (v.info.detail.state === 'done' ? 'Realizada' : (v.info.detail.state === 'cancel' ? 'Cancelada' : 'Disponível'))) + ' (' + v.info.category + ')' + (v.info.inscritos[0]!== undefined && v.info.inscritos[0]['name'] !== undefined && v.info.inscritos[0]['name'] !== '' ? (' [Responsável: ' +  v.info.inscritos[0]['name']) + '; Nível: ' + v.info.inscritos[0]['classe_level'] + '; Alunos: ' + v.info.inscritos.length + ']' : ''),
                            category: v.info.detail.category,
                            dueDateClass: v.info.detail.dueDateClass,
                            start: v.info.detail.start,
                            end: v.info.detail.end,
                            isAllDay: v.info.detail.isAllDay,
                            location: v.info.detail.location,
                            state: v.info.detail.state,
                            raw: v.info.detail.raw,
                            isReadOnly: v.info.detail.isReadOnly,
                            instrutor: {
                                id: v.info.instrutor.id,
                                name: v.info.instrutor.name
                            }
                        })
                    }
                })

                setSchedueles(aux_schedueles)
                setRefresh(refresh + 1)
                // console.log('aux_schedueles', aux_schedueles)

            })
            .catch(() => 404)

            return 
            /*
            await reqGET(`${api_crud_base}/app/estancia/aula/event/${getTokenInfo().companycode}`)
                .then(res => { 
                    //setData(res.data); setLoading(false) 
                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        aux_schedueles.push({
                            id: v.id,
                            companycode: v.info.companycode,
                            calendarId: v.info.calendarId,
                            title: v.info.title,
                            category: v.info.category,
                            dueDateClass: v.info.dueDateClass,
                            start: v.info.start,
                            end: v.info.end,
                            isAllDay: v.info.isAllDay,
                            location: v.info.location,
                            state: v.info.state,
                            raw: v.info.raw,
                            isReadOnly: v.info.isReadOnly
                        })
                    })

                    setSchedueles(aux_schedueles)
                })
                .catch(() => 404)
                */
    }

    useEffect(() => {


        var today_2 = new Date()

        const get_events_2 = async (start, end) => {

            //await reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${start}`)
            await reqGET(`${api_crud_base}/estancia/aula/event/instrutor/range/${getTokenInfo().companycode}/${props.location.state.item.id}/${start}/${end}`)
                .then(res => { 
    
                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        if(v.info.instrutor.id === props.location.state.item.id) {
                            // console.log(v.info.detail.state)
                            aux_schedueles.push({
                                id: v.id,
                                companycode: v.info.companycode,
                                //calendarId: v.info.detail.calendarId,
                                calendarId: v.info.detail.state === 'busy' ? '0' : (v.info.detail.state === 'done' ? '2' : v.info.detail.state === 'cancel' ? '3' : '1'),
                                //title: (v.info.detail.name !== undefined && v.info.detail.name !== '' ? v.info.detail.name : 'Disponível'),
                                title: (v.info.detail.state === 'busy' ? 'Agendada' : (v.info.detail.state === 'done' ? 'Realizada' : (v.info.detail.state === 'cancel' ? 'Cancelada' : 'Disponível'))) + ' (' + v.info.category + ')' + (v.info.inscritos[0]!== undefined && v.info.inscritos[0]['name'] !== undefined && v.info.inscritos[0]['name'] !== '' ? (' [Responsável: ' +  v.info.inscritos[0]['name']) + '; Nível: ' + v.info.inscritos[0]['classe_level'] + '; Alunos: ' + v.info.inscritos.length + ']' : ''),
                                category: v.info.detail.category,
                                dueDateClass: v.info.detail.dueDateClass,
                                start: v.info.detail.start,
                                end: v.info.detail.end,
                                isAllDay: v.info.detail.isAllDay,
                                location: v.info.detail.location,
                                state: v.info.detail.state,
                                raw: v.info.detail.raw,
                                isReadOnly: v.info.detail.isReadOnly,
                                instrutor: {
                                    id: v.info.instrutor.id,
                                    name: v.info.instrutor.name
                                }
                            })
                        }
                    })
    
                    setSchedueles(aux_schedueles)
                    // console.log('aux_schedueles', aux_schedueles)
    
                })
                .catch(() => 404)
    
                return 
                /*
                await reqGET(`${api_crud_base}/app/estancia/aula/event/${getTokenInfo().companycode}`)
                    .then(res => { 
                        //setData(res.data); setLoading(false) 
                        let aux_schedueles = []
                        res.data.forEach((v) => {
                            aux_schedueles.push({
                                id: v.id,
                                companycode: v.info.companycode,
                                calendarId: v.info.calendarId,
                                title: v.info.title,
                                category: v.info.category,
                                dueDateClass: v.info.dueDateClass,
                                start: v.info.start,
                                end: v.info.end,
                                isAllDay: v.info.isAllDay,
                                location: v.info.location,
                                state: v.info.state,
                                raw: v.info.raw,
                                isReadOnly: v.info.isReadOnly
                            })
                        })
    
                        setSchedueles(aux_schedueles)
                    })
                    .catch(() => 404)
                    */
        }

        set_modal_date(today_2.getFullYear() + '-' + ((today_2.getMonth() + 1) + '').padStart(2, '0') + '-' + (today_2.getDate() + '').padStart(2, '0'))

        set_lang(localStorage.getItem('lang'))

        let d1 = new Date(today_2.getFullYear(), today_2.getMonth(), 1)
        let d2 = new Date(today_2.getFullYear(), today_2.getMonth() + 1, 0)

        let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
        let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

        get_events_2(start, end)
        //get_events(data)

        set_modal_instrutor_id(props.location.state.item.id)
        set_modal_instrutor_name(props.location.state.item.name)

        set_modal_category('Ski')
        set_modal_category_id('1')

        setCalendars([
            {
                id: '0',
                name: 'Busy',
                bgColor: '#9e5fff',
                borderColor: '#9e5fff',
                color: '#ffffff',
                status: true
            },
            {
                id: '1',
                name: 'Free',
                bgColor: '#03bd9e',
                borderColor: '#03bd9e',
                color: '#ffffff',
                status: true
            },
            {
                id: '2',
                name: 'Done',
                bgColor: '#00a9ff',
                borderColor: '#00a9ff',
                color: '#ffffff',
                status: true
            },
            {
                id: '3',
                name: 'Cancel',
                bgColor: '#ff4040',
                borderColor: '#ff4040',
                color: '#ffffff',
                status: true
            }
        ])

        //setSchedueles(aux_schedueles)
        //setCalendars(aux_calendars)
        // setcalendarTitle(today.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
        // setcalendarTitle(today.toLocaleString(language[localStorage.getItem('lang')].calendar_language, { month: 'long', year: 'numeric' }))
        setLoading(false)
        
        
    }, [props]);

	const max_id_array = (array) => {
		let max_value = Math.max.apply(Math, array.map(function(o) { return o.id; }))

		array.forEach(v => {
			if(v.children && v.children.length > 0) {
				let max_value_2 = max_id_array(v.children)

				if(max_value_2 > max_value)
					max_value = max_value_2
			}
		})

		return max_value
	}

    const addDateScheduel = (e) => {
        const { calendarId, title, start, end, isAllDay, isPrivate, location, state, raw } = e;
        const companycode = getTokenInfo().companycode;
        
        let aux_id = max_id_array(schedueles)
        let aux_scheduel = {
            /*id: (aux_id + 1).toString(),*/
            companycode: companycode,
            calendarId: calendarId,
            title: title,
            category: (isAllDay ? 'allday' : 'time'),
            dueDateClass: '',
            start: start._date,
            end: end._date,
            isAllDay: isAllDay,
            location: location,
            state: state,
            raw: raw ,
            isReadOnly: (isPrivate === 'private' ? true : false)
        }

        // console.log(aux_scheduel)
        // setSchedueles([...schedueles, aux_scheduel])

        // return

        Swal.fire({
            title: 'Novo Registo',
            text: "Tem a certeza que pretende continuar?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        })
        .then((result) => {
            if (result.isConfirmed) {
                reqPOST(api_crud_route(), {id: '', info: aux_scheduel})
                    .then(() => { 
                        aux_schedueles['id'] = (aux_id + 1).toString()
                        setSchedueles([...schedueles, aux_scheduel])
                        //props.history.push(endpoints.list) 
                    })
                    .catch((erro) => {
                        console.log('Problema ao atualizar Registo!: ', erro)
                    })
            }
        })
    }

    const editDateScheduel = (e) => {
        const { schedule, changes } = e;

        let aux_scheduel = schedueles.filter(v => v.id === schedule.id)
        let aux_schedueles = schedueles.filter(v => v.id !== schedule.id)

        aux_schedueles.push(aux_scheduel[0])
        aux_schedueles.forEach((v) => {
            if(v.id === schedule.id) {
                var obj = changes;
                for(var key in obj) {
                    var value = obj[key];
                    //console.log(key + ": " + value);
                    v[key] = value
                }

            }
        })

        //console.log(aux_schedueles)
        setSchedueles(aux_schedueles)
    }

    const editAula = (e) => {
        const { schedule } = e;

        let d = schedule.start.getFullYear() + '-' + ((schedule.start.getMonth() + 1) + '').padStart(2, '0') + '-' + (schedule.start.getDate() + '').padStart(2, '0')

        let hs = schedule.start.getHours() < 10 ? '0' + schedule.start.getHours() : schedule.start.getHours()
        let ms = schedule.start.getMinutes() < 10 ? '0' + schedule.start.getMinutes() : schedule.start.getMinutes()

        let he = schedule.end.getHours() < 10 ? '0' + schedule.end.getHours() : schedule.end.getHours()
        let me = schedule.end.getMinutes() < 10 ? '0' + schedule.end.getMinutes() : schedule.end.getMinutes()

        Swal.fire({
			title: language[lang].edit_aula_title,
			text: language[lang].edit_aula_text,
			icon: 'question',
			showCancelButton: true,
			showDenyButton: true,
			confirmButtonColor: '#0095e8',
			denyButtonColor: '#d9214e',
			cancelButtonColor: '#6c757d',
			confirmButtonText: language[lang].edit_aula_confirm,
			cancelButtonText: language[lang].edit_aula_cancel,
            denyButtonText: language[lang].edit_aula_deny,
		})
		.then((result) => {

            if(result.isConfirmed) {

                reqGET(`${api_crud_base}/estancia/aula/event/${getTokenInfo().companycode}/${schedule.id}`)
                    .then(res => { 

                        let modal_horario = []
                        modal_horario.push({begin: hs + ':' + ms, end: he + ':' + me})

                        let dados = res.data[0]
                        dados.info.detail['state'] = 'done'

                        modal_horario.forEach(el => {
                            dados.info.detail.start = d + 'T' + (hs + ':' + ms)
                            dados.info.detail.end = d + 'T' + (he + ':' + me)
                
                            reqPUT(`${api_crud_base}/estancia/aula/event`, dados)
                                .then(() => { 
                                    //props.history.push(endpoints.list) 
                                    setRefresh(refresh + 1)
                                })
                                .catch(() => '', Swal.fire(language[lang].insert_error, 'info'))
                
                        })

                    })

            }
            else if(result.isDismissed) {

            }
            else if(result.isDenied) {

                reqGET(`${api_crud_base}/estancia/aula/event/${getTokenInfo().companycode}/${schedule.id}`)
                    .then(res => { 

                        let modal_horario = []
                        modal_horario.push({begin: hs + ':' + ms, end: he + ':' + me})

                        let dados = res.data[0]
                        dados.info.detail['inscritos'] = []
                        dados.info.detail['inscritos'].push({name: '', age: '', identification_type: '', identification_number: '', codigo_compra: '' })
                        dados.info.detail['state'] = 'cancel'

                        modal_horario.forEach(el => {
                            dados.info.detail.start = d + 'T' + (hs + ':' + ms)
                            dados.info.detail.end = d + 'T' + (he + ':' + me)
                
                            reqPUT(`${api_crud_base}/estancia/aula/event`, dados)
                                .then(() => { 
                                    //props.history.push(endpoints.list) 
                                    setRefresh(refresh + 1)
                                })
                                .catch(() => Swal.fire('', language[lang].insert_error, 'info'))
                
                        })

                    })
            } 

		})

        
    }

    const removeDateScheduel = (e) => {
        const { schedule } = e;

        let aux_schedueles = schedueles.filter(v => v.id !== schedule.id)
        setSchedueles(aux_schedueles)
    }

    const myTheme = {
        // Theme object to extends default dark theme.
    };
      
    const myTemplate = {
        // milestone(schedule) {
        //     return `<span style="color:#fff;background-color: ${schedule.bgColor};">${schedule.title}</span>`;
        // },
        // milestoneTitle() {
        //     return 'Milestone';
        // },
        // task: function(schedule) {
        //     return '#' + schedule.title;
        // },
        // taskTitle: function() {
        //     return '<span className="tui-full-calendar-left-content">Tarefa</span>';
        // },
        // allday(schedule) {
        //     return `${schedule.title}<i className="fa fa-refresh"></i>`;
        // },
        // alldayTitle() {
        //     return language[lang].calendar_allday;
        // },
        // popupIsAllDay: function() {
        //     return language[lang].calendar_allday;
        // },
        popupStateFree: function() {
            return language[lang].calendar_free;
        },
        popupStateBusy: function() {
            return language[lang].calendar_busy;
        },
        titlePlaceholder: function() {
            return language[lang].calendar_title_placeholder;
        },
        locationPlaceholder: function() {
            return language[lang].calendar_location_placeholder;
        },
        startDatePlaceholder: function() {
            return language[lang].calendar_start_placeholder;
        },
        endDatePlaceholder: function() {
            return language[lang].calendar_end_placeholder;
        },
        popupSave: function() {
            return language[lang].calendar_save;
        },
        popupUpdate: function() {
            return language[lang].calendar_update;
        },
        // popupDetailDate: function(isAllDay, start, end) {
        //     var isSameDate = moment(start).isSame(end);
        //     var endFormat = (isSameDate ? '' : 'YYYY.MM.DD ') + 'hh:mm a';

        //     if (isAllDay) {
        //         return moment(start).format('YYYY.MM.DD') + (isSameDate ? '' : ' - ' + moment(end).format('YYYY.MM.DD'));
        //     }

        //     return (moment(start).format('YYYY.MM.DD hh:mm a') + ' - ' + moment(end).format(endFormat));
        // },
        popupEdit: function() {
            return language[lang].calendar_edit;
        },
        popupDelete: function() {
            return language[lang].calendar_delete;
        }
    }

    const calendarRef = React.createRef();
    const handleClickButton = (type) => {
        const calendarInstance = calendarRef.current.getInstance();

        if(type === 'today') {
            calendarInstance.today();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
            set_modal_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
        }
        if(type === 'prev') {
            calendarInstance.prev();
            
            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
            set_modal_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
        }
        if(type === 'next') {
            calendarInstance.next();
            
            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
            set_modal_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
        }

        if(type === 'day') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'week') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'month') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }

        if(calendarInstance.getViewName() === 'day') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
        }
        if(calendarInstance.getViewName() === 'week') {
            setcalendarTitle(calendarInstance.getDateRangeStart()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + ' ~ ' + calendarInstance.getDateRangeEnd()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })) 
        }
        if(calendarInstance.getViewName() === 'month') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { month: 'long', year: 'numeric' }))
        }

        //calendarInstance.toggleSchedules('0', true, true)

        //console.log(calendarInstance.getViewName())
        // console.log(calendarInstance.getDate())
        // console.log(calendarInstance.getDate()._date)
        // console.log(calendarInstance.getDate()._date.toLocaleString('default', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
    };
    const handleToggleButton = (e) => {
        const { value, dataset } = e.target
        const { status } = dataset

        let toHide = true
        let toHideChild = true
        let render = true

        const calendarInstance = calendarRef.current.getInstance();
        if(value === "all") {
            if(status === 'true') {
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                e.target.dataset.status = false
                toHide = true
            }
            else {
                //document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                e.target.dataset.status = true
                toHide = false
            }

            if(status !== 'true')
                toHideChild = false
            
            calendars.forEach((v) => {
                if(toHide) {
                    document.getElementById('calendar-' + v.id).dataset.status = false
                    // document.getElementById('calendar-' + v.id).removeAttribute('checked')
                    document.getElementById('calendar-' + v.id).checked = false
                    v.status = false
                }
                else {
                    document.getElementById('calendar-' + v.id).dataset.status = true
                    // document.getElementById('calendar-' + v.id).setAttribute('checked', 'checked')
                    document.getElementById('calendar-' + v.id).checked = true
                    v.status = true
                }
    
                calendarInstance.toggleSchedules(v.id, toHideChild, render)
            })
        }
        else {
            if(status === 'true') {
                document.getElementById('calendar-' + value).dataset.status = false
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                toHide = true
            }
            else {
                document.getElementById('calendar-' + value).dataset.status = true
                // document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                toHide = false
            }

            let allChecked = true
            calendars.forEach((v) => {
                if(document.getElementById('calendar-' + v.id).dataset.status === 'false')
                    allChecked = false
            })

            if(allChecked) {
                document.getElementById('calendar-all').dataset.status = true
                document.getElementById('calendar-all').checked = true
            }
            else {
                document.getElementById('calendar-all').dataset.status = false
                document.getElementById('calendar-all').checked = false

            }

            calendarInstance.toggleSchedules(value, toHide, render)
        }
    }

    const change_aulas_type = e => {
        set_modal_category(e.value)

        if (e.value.localeCompare('Ski') === 0) {
			set_modal_category_id('1')
		}
		else if (e.value.localeCompare('Snowboard') === 0) {
			set_modal_category_id('2')
		}
    }

    const change_aulas_date = e => {

        horario.forEach((element) => {
            element.state = true
        })

        if(modal_instrutor_id !== '') {
            reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${e.target.value}`)
                .then(res => { 

                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        if(v.info.detail.start.includes(e.target.value) && v.info.instrutor.id === modal_instrutor_id) {
                            aux_schedueles.push({
                                start: v.info.detail.start,
                                end: v.info.detail.end,
                            })

                            let x = horario
                            // x.forEach((element) => {
                            //     if(v.info.detail.start.includes(element.begin)) {
                            //         element.state = false
                            //     }
                            // })
                            set_horario(x)
                            console.log('x', x)
                        }
                    })

                    set_horarios_agendados(aux_schedueles)
                    setRefresh(refresh + 1)
                    console.log('aux_schedueles', aux_schedueles)

                })
                .catch(() => 404)
        }

        set_modal_date(e.target.value)
        console.log(e.target.value)

    }

    const change_aulas_instrutor = e => {
        console.log(e)

        horario.forEach((element) => {
            element.state = true
        })

        if(modal_date !== '') {
            reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${modal_date}`)
                .then(res => { 

                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        if(v.info.detail.start.includes(modal_date) && v.info.instrutor.id === e.value) {
                            aux_schedueles.push({
                                start: v.info.detail.start,
                                end: v.info.detail.end,
                            })

                            let x = horario
                            // x.forEach((element) => {
                            //     if(v.info.detail.start.includes(element.begin)) {
                            //         element.state = false
                            //     }
                            // })
                            set_horario(x)
                            console.log('x', x)
                            setRefresh(refresh + 1)
                        }
                    })

                    set_horarios_agendados(aux_schedueles)
                    setRefresh(refresh + 1)
                    console.log('aux_schedueles', aux_schedueles)

                })
                .catch(() => 404)
        }
        
        set_modal_instrutor_id(e.value)
        set_modal_instrutor_name(e.label)
            
    }

    const handleInsert = () => {
        let dados = JSON.parse(JSON.stringify(data_interface_event))
        dados.info.companycode = getTokenInfo().companycode
        dados.info.name = modal_name
        dados.info.category = modal_category
        dados.info.detail['calendarId'] = modal_category_id
        dados.info.instrutor.id = modal_instrutor_id
        dados.info.instrutor.name = modal_instrutor_name

        console.log('modal_horario', modal_horario)

        // if(modal_name === '') {
        //     Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_name, 'info')
        //     return
        // }
        if(modal_instrutor_id === '') {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_instrutor, 'info')
            return
        }if(modal_category_id === '') {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_category, 'info')
            return
        }
        if(modal_date === '') {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_date, 'info')
            return
        }
        if(modal_horario.length === 0) {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_horario, 'info')
            return
        }

        horario.forEach((_, k_el) => {
            document.getElementById('horario_' + k_el).checked = false
        })

        modal_horario.forEach((el) => {
            dados.info.detail.start = modal_date + 'T' + el.begin
            dados.info.detail.end = modal_date + 'T' + el.end

            reqPOST(api_crud_base + '/estancia/aula/event', dados)
                .then(() => { 
                    //props.history.push(endpoints.list) 

                    let d1 = new Date(modal_date)
                    let d2 = new Date(modal_date)
            
                    let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
                    let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

                    get_events(start, end)
                    setRefresh(refresh + 1)
                })
                .catch(() => Swal.fire('', language[lang].insert_error, 'info'))

        })

        // setRefresh(refresh + 1)

    }

    /*
    const handleEdit = () => {
        let dados = JSON.parse(JSON.stringify(data_interface))
        dados.id = modal_event_id
        dados.info.companycode = getTokenInfo().companycode
        dados.info.name = modal_name
        dados.info.category = modal_category
        dados.info.detail['calendarId'] = modal_category_id
        dados.info.instrutor.id = modal_instrutor_id
        dados.info.instrutor.name = modal_instrutor_name

        if(modal_instrutor_id === '') {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_instrutor, 'info')
            return
        }
        if(modal_date === '') {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_date, 'info')
            return
        }
        if(modal_horario.length === 0) {
            Swal.fire('', language[lang].insert_error + ' ' + language[lang].insert_error_horario, 'info')
            return
        }

        modal_horario.forEach(el => {
            dados.info.detail.start = modal_date + 'T' + el.begin
            dados.info.detail.end = modal_date + 'T' + el.end

            reqPUT(api_crud_route, dados)
                .then(() => { 
                    //props.history.push(endpoints.list) 
                })
                .catch(() => Swal.fire('', language[lang].insert_error, 'info'))

        })

        setRefresh(refresh + 1)

    }
    */

    const handleSelectHorario = e => {
		const { dataset } = e.target;
		const { begin, end } = dataset;

        let aux = modal_horario.filter(el => el.begin === begin)
        if(aux.length === 0) {
            modal_horario.push({begin: begin, end: end})

            set_modal_horario(modal_horario)
        }
        else {
            let x = modal_horario.filter(el => el.begin !== begin)

            set_modal_horario(x)
        }

		// setRefresh(refresh + 1)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados.current.info))
	}

    const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
            padding: "0px 5px",
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "0px 5px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
            padding: "0px 5px",
		}),
        indicatorContainer: base => ({
			...base,
            padding: "0px 5px",
        }),
	}

    return (isloading ?
        
        <Loader />

    :

        <main>
            <div className={`dash-cards dash-cards-calendar header`}>
                <h2 className="dash-title">{language[lang].scale}</h2>
                <p>{language[lang].entity} / {language[lang].scale}</p>
            </div>
        
            <div className={`dash-cards dash-cards-calendar body`}>
                <div className="container">
                    <div className="card">
                        <div className="card-body d-none">
                            <h2 className="dash-title">
                                {language[lang].scale}
                            </h2>
                        </div>

                        <div className="card-body">

                            <div className="calendar estancia">
                                <div className="calendar-header text-end">


                                    <div className="col-12 mt-5 mb-3 px-5">

                                        <span 
                                            className="btn btn-sm btn-secondary rounded-0 multi-item me-1"
                                            data-bs-toggle="modal" 
                                            data-bs-target={"#insert_modal"}
                                            title={language[lang].add_new_2}
                                            onClick={() => set_modal_horario([])}
                                        >
                                            <span>{language[lang].add_new_2}</span>
                                        </span>
                                        <span className="d-none" id="btn_edit_modal" data-bs-toggle="modal" data-bs-target={"#edit_modal"} onClick={() => set_modal_horario([])} />

                                    </div>


                                    <div className="col-12 d-flex flex-stack my-5 px-5">
                                        <div className="flex-1 text-start">
                                            <button type="button" className="btn btn-sm btn-light move-day" onClick={() => handleClickButton('prev')} data-action="move-prev">
                                                <i className="bi bi-chevron-left" data-action="move-prev"></i>
                                            </button>
                                            <button type="button" className="btn btn-sm btn-light move-day" onClick={() => handleClickButton('next')} data-action="move-next">
                                                <i className="bi bi-chevron-right" data-action="move-next"></i>
                                            </button>

                                            <button type="button" className="btn btn-sm btn-light move-today ms-3" onClick={() => handleClickButton('today')} data-action="move-today">{language[lang].calendar_today}</button>
                                        </div>

                                        <div className="flex-1 text-center">
                                            <h4 className="m-0">{calendarTitle}</h4>
                                        </div>

                                        <div className="flex-1 text-end">
                                            {
                                            calendar_views.map((v, k) => {
                                                return (
                                                    <button key={k} type="button" aria-pressed={selectedView === v.value ? "true" : "false"} className={selectedView === v.value ? "btn btn-sm btn-secondary" : "btn btn-sm btn-light"} onClick={() => handleClickButton(v.value)}>{v.name}</button>
                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="calendar-body">

                                    <div className="col-12 px-5">
                                        <div className="row">
                                            <div className="col-2 d-none">
                                                <div className="calendars">
                                                    <div className="btn-calendars">
                                                        <div className="form-check form-check-custom form-check-solid  my-2">
                                                            <input className="form-check-input" type="checkbox" id="calendar-all" defaultChecked="checked" data-status="true" value="all" onClick={handleToggleButton} />
                                                            <label className="form-check-label" htmlFor="calendar-all">
                                                                <strong>{language[lang].calendar_viewall}</strong>
                                                            </label>
                                                        </div>
                                                        {
                                                        calendars.map((v, k) => {
                                                            return (
                                                                <div key={k} className="form-check form-check-custom form-check-solid my-2">
                                                                    <input type="radio" className="form-check-input rounded-circle" data-s={v.status} style={{backgroundColor: v.bgColor, borderColor: v.borderColor}} id={'calendar-' + v.id} defaultChecked="checked" data-status="true" value={v.id} onClick={handleToggleButton} />
                                                                    <label className="form-check-label" htmlFor={'calendar-' + v.id}>
                                                                        {v.name}
                                                                    </label>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <Calendar
                                                    ref={calendarRef}
                                                    height="auto"
                                                    calendars={calendars}
                                                    disableDblClick={true}
                                                    disableClick={false}
                                                    isReadOnly={true}
                                                    month={{
                                                        startDayOfWeek: 0,
                                                        daynames: language[lang].calendar_daynames
                                                    }}
                                                    schedules={schedueles}
                                                    scheduleView
                                                    taskView={false}
                                                    template={myTemplate}
                                                    theme={myTheme}
                                                    timezones={[
                                                        {
                                                            timezoneName: 'Europe/Lisbon',
                                                            displayLabel: 'GMT+00:00',
                                                            tooltip: 'Lisbon'
                                                        }
                                                    ]}
                                                    useDetailPopup
                                                    useCreationPopup
                                                    view={selectedView}
                                                    week={{
                                                        hourStart: 8,
                                                        hourEnd: 19,
                                                        showTimezoneCollapseButton: true,
                                                        timezonesCollapsed: true,
                                                        daynames: language[lang].calendar_daynames
                                                    }}
                                                    onAfterRenderSchedule={() => { }}
                                                    onBeforeDeleteSchedule={(e) => {removeDateScheduel(e) }}
                                                    onClickDayname={() => { }}
                                                    onClickSchedule={(e) => { editAula(e) }}
                                                    onClickTimezonesCollapseBtn={() => { }}
                                                    onBeforeUpdateSchedule={(e) => { editDateScheduel(e) }}
                                                    onBeforeCreateSchedule={(e) => { addDateScheduel(e) }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="modal bg-light fade" tabIndex="-1" id={"insert_modal"}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{language[lang].add_new}</h5>

                                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i className="bi bi-x fs-2"></i>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className="row mb-3 d-none">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].field_name}</label>
                                            <input type="text" className="form-control mb-3" name="name" value={modal_name} onChange={(e) => set_modal_name(e.target.value)} placeholder={"Nome"} /> 
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].table_date}</label>

                                            <input type="date" className="form-control rounded-0" name="date" value={modal_date} onChange={(e) => change_aulas_date(e)} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3 d-none">
                                            <label className="fs-5 fw-bold mb-2">{language[lang].instrutor}</label>
                                            
                                            <Select
                                                className="div-select"
                                                options={instrutores}
                                                name="client_type"
                                                value={modal_instrutor_id === '' ? null : { label: modal_instrutor_name, value: modal_instrutor_id }}
                                                placeholder={language[lang].instrutor_placeholder}
                                                onChange={change_aulas_instrutor}
                                                styles={custom_select_styles}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="fs-5 fw-bold mb-2">{language[lang].aulas_type}</label>
                                            
                                            <Select
                                                className="div-select"
                                                options={aulas_types}
                                                name="client_type"
                                                value={modal_category === '' ? null : { label: modal_category, value: modal_category }}
                                                placeholder={language[lang].aulas_type_placeholder}
                                                onChange={change_aulas_type}
                                                styles={custom_select_styles}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3 ms-1 mt-2">
                                        {
                                        horario.map((element, key) => {
                                            return (
                                                <div key={key} className="col-6 col-sm-4 mb-3 form-check">
                                                    <label className={"form-check-label text-nowrap" + (element.state ? '' : ' disabled')} htmlFor={"horario_" + key}>
                                                        {element.begin} - {element.end}
                                                    </label>
                                                    <input 
                                                        id={"horario_" + key}
                                                        name={"horario_" + key}
                                                        value={element.begin}
                                                        data-begin={element.begin}
                                                        data-end={element.end}
                                                        type="checkbox" 
                                                        className={'form-check-input rounded-0'}
                                                        onChange={handleSelectHorario}
                                                        disabled={!element.state}
                                                        //defaultChecked={handleForfaitCheckVerify(element.id)}
                                                    />
                                                </div>
                                            )
                                        })
                                        }
                                    </div>

                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleInsert}>{language[lang].save}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'dash-cards footer'}>
                <nav className="navbar bottom-navbar navbar-light">
                    <div className="navbar-footer">
                        <ul className="navbar-nav float-left"></ul>
                        <ul className="navbar-nav float-right">
                            <li className="nav-item">
                                <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                    <i className="bi bi-chevron-left me-2"></i>
                                    <span>{language[lang].back}</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </main>
    )
}
